import React from "react";
import { CONTAINER_TYPE } from "../data";

const getType = (type) => {
  switch (type) {
    case CONTAINER_TYPE.CRATE:
      return (
        <div className="h-[26px] max-w-max px-2 flex items-center bg-primary-10 rounded-md">
          <p className="font-poppins font-medium text-xs leading-[100%] text-primary">
            Crate
          </p>
        </div>
      );

    case CONTAINER_TYPE.CANISTER:
      return (
        <div className="h-[26px] max-w-max px-2 flex items-center bg-light-blue-10 rounded-md">
          <p className="font-poppins font-medium text-xs leading-[100%] text-light-blue">
            Canister
          </p>
        </div>
      );

    default:
      return <div />;
  }
};

export default getType;
